
import _ from 'lodash'


const useWaitlistForm = ({formik})=>{

    const onChanged = (e)=>{           
        switch(e.target.id){
            case "clientType":
            case "client":
            case "pendingClientName":
            case "waitlist":
            case "priority":  
            case "notes":  
                formik.handleChange(e);   
                break;       
            default:
                formik.handleChange(e);   
                break;

        }   
      
    }

    return {data:{}, actions:{onChanged}}


}

export default useWaitlistForm